import React from 'react';
import styled from 'styled-components/macro';
import { EmptyPlaceholder } from '../../../shared/EmptyPlaceholder';
import { CustomerQuotesResponse } from '../../projects/projectQuotesAndDesignsResponse';
import { CustomerQuotes } from './CustomerQuotes';

type Props = {
  projectId: number;
  customerQuotes: Array<CustomerQuotesResponse>;
};

export const ProjectQuotes = ({ projectId, customerQuotes }: Props) => {
  return (
    <Container>
      {customerQuotes.map(customerQuotesResponse => (
        <CustomerQuotes
          key={customerQuotesResponse.customerId}
          projectId={projectId}
          customerQuotesResponse={customerQuotesResponse}
        />
      ))}
      {customerQuotes.length === 0 && <EmptyPlaceholder message="No Quotes have been created for this Project yet." />}
    </Container>
  );
};

const Container = styled.div``;
